module.exports = __webpack_public_path__ + "r-v3/img/ico_chat_send_impossible.41e3ba3e.svg";